import { render, staticRenderFns } from "./selectChannels.vue?vue&type=template&id=9ecb9768&scoped=true&"
import script from "./selectChannels.vue?vue&type=script&lang=js&"
export * from "./selectChannels.vue?vue&type=script&lang=js&"
import style0 from "./selectChannels.vue?vue&type=style&index=0&id=9ecb9768&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb9768",
  null
  
)

export default component.exports